import CurrentServices from "./current-service";

const Offers: React.FC = () => {
  return (
    <div>
      <div className="mt-1">
        <h3 className="text-xl font-semibold text-[#111827]">Services</h3>
        <CurrentServices />
      </div>
    </div>
  );
};

export default Offers;
